export default "<app-repozytorium></app-repozytorium>";